// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface Props {
    message?: string;
}

const ServerError: React.FC<Props> = ({ message }) => {
    const { t } = useTranslation();
    const displayMessage = message || t('serverErrorPage.defaultMessage');

    return (
        <section className="space-ptb bg-holder">
            <div className="container">
                <div className="row justify-content-center align-items-center">
                    <div className="col-md-12 text-center">
                        <div className="error-404">
                            <h1>{t('serverErrorPage.errorCode', '500')}</h1>
                            <strong>{displayMessage}</strong>
                            <Link
                                className="btn btn-primary mt-4"
                                title={t('navigation.homeLinkTitle') || 'Home'}
                                to="/"
                            >
                                {t('serverErrorPage.backToHomeButton')}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServerError;